import { Star, Quote } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const testimonials = [
  {
    name: "Ana Paula Ribeiro",
    business: "Bloom Studio",
    segment: "Fisioterapeuta",
    location: "Curitiba, PR",
    text: "Criei minha marca profissional em menos de 10 minutos. Meus clientes adoraram o visual novo!",
    rating: 5
  },
  {
    name: "Carlos Eduardo",
    business: "Urban Eats",
    segment: "Fornecimento de Alimentos",
    location: "Campinas, SP",
    text: "Economizei mais de R$2.000 que gastaria com designer. A logo ficou incrível e profissional!",
    rating: 5
  },
  {
    name: "Fernanda Costa",
    business: "Bella Moda",
    segment: "Vestuário",
    location: "Salvador, BA",
    text: "Finalmente tenho uma identidade visual profissional para minha loja. Recomendo demais!",
    rating: 5
  }
];

export const SocialProof = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-secondary/30">
      <div className="container mx-auto px-5 sm:px-6">
        {/* Stats Counter */}
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Star className="h-4 w-4 fill-primary" />
            <span className="text-sm font-medium">Mais de 200 marcas geradas</span>
          </div>
          <h2 className="heading-section text-foreground mb-4 text-balance">
            O que nossos clientes dizem?
          </h2>
          <p className="subtitle-section max-w-2xl mx-auto">
            Milhares de empreendedores já acessaram o ClickLogos e estão melhorando
            suas comunicações impressas e digitais. Preço promocional do mês
            de lançamento da plataforma. Vai ficar de fora dessa?
          </p>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="p-5 sm:p-6 bg-background border-border/50 hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4 mb-4">
                <Avatar className="w-14 h-14 border-2 border-primary/20">
                  <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.business}</p>
                  <span className="text-xs text-primary font-medium">{testimonial.segment}</span>
                  <p className="text-xs text-muted-foreground mt-0.5">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              <div className="relative">
                <Quote className="h-6 w-6 text-primary/20 absolute -top-1 -left-1" />
                <p className="text-muted-foreground pl-5 italic">
                  "{testimonial.text}"
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};